import DirectoryHomePage from "../components/DirectoryHomePage.vue";
import DirectoryDetailPage from "../components/DirectoryDetailPage.vue";
export default {
  children: [
    {
      path: "",
      name: "directory-home",
      component: DirectoryHomePage,
       meta: { countViews: true }
    },
    {
      path: ":id",
      name: "directory-detail",
      component: DirectoryDetailPage,
      props: true,
       meta: { countViews: true }
    },
  ],
};
